import { RecordTypesConfig } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';
import { IAuditTrailAlignField } from "../interfaces";

export const generalFieldsHide = ['businessUnitId', 'permissions.id', 'defaultCurrency.id', 'cells.lookupId', 'lookupSetup.category', 'lookupSetup.type', 'cells.sequence', 'cells.fieldName', 'company.id', 'company.code'];

export const fieldNameMapConfig: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Code',
  'name': 'Name',
  'createdAt': 'Created At',
  'createdBy': 'Created By',
  'businessUnitId': 'Company ID',
  'updatedAt': 'Updated At',
  'updatedBy': 'Updated By',
  'deletedAt': 'Deleted At',
  'deletedBy': 'Deleted By',
  'uploadedAt': 'Uploaded At',
  'uploadedBy': 'Uploaded By',
  'type': 'Type',
  'gstCode': 'GST Category',
  'effectiveDate': 'Effective Date',
  'company.name': 'Company',
  'status': 'Status',
  'description': 'Description',

  //roles
  'permissions': 'Permissions',
  'permissions.group': 'Group',
  'permissions.slug': 'Permission',

  //permission
  'group': 'Portal',
  'module': 'Module',
  'feature': 'Feature',
  'scope': 'Activity',
  'sequence': 'Sequence',
  'isHidden': 'Hidden',

  //LookupTable
  'displayName': 'Name',
  'category': 'Category',
  'key': 'Lookup Setup Key',
  'cols': 'Cols',
  'lookupSetup.displayName': 'Name',
  'lookupSetup.key': 'Lookup Setup Key',
  'cells': 'Setup',
  'cells.displayName': 'Name',
  'cells.fieldName': 'Name',
  'cells.value': 'Value',

  //country
  'defaultCurrency': 'Default Currency',
  'defaultCurrency.name': 'Default Currency',
  'isDefault': 'Default',
  //currency
  'exchange': 'FOREIGN Currency → SGD',
  'value': 'SGD → FOREIGN Currency',
  'history.exchange': 'FOREIGN Currency → SGD',
  'history.value': 'SGD → FOREIGN Currency',
  'history.effectiveDate': 'Effective From',

  //ID type 
  'iras': 'IRAS',
  'identification': 'Identification',

  //bank
  'swiftCode': 'SWIFT/BIC Code',
  'maxAccountDigit': 'Max Account Digits',
  'minAccountDigit': 'Min Account Digits',

  'isActive': 'Status',
  'categoryType': 'Tagger',

  //Receipt Mode
  'receiptAccounts': 'Receipt Accounts',
  'receiptAccounts.accountCode': 'Code',
  'receiptAccounts.accountName': 'Name',
  'receiptAccounts.isDefault': 'Default',
  'isReferenceFieldEnabled': 'Enable Reference Field',
  'referenceLabel': 'Label Reference Name',

};

export const userAccountFieldsHide = [
  'address.buildingName',
  'address.district',
  'address.floor',
  'address.house',
  'address.street',
  'address.unit',
  'address.postalCode',
  'address.addressLine1',
  'address.addressLine2',
  'address.addressLine3',
  'companies.id',
  'companies.code',
  'roles.id',
  'roles.code'

]
export const fieldNameMapUserAccount: { [key: string]: string } = {
  //user account
  'username': 'Login ID',
  'email': 'Email',
  'dateOfBirth': 'Date Of Birth',
  'address.address': 'Address',
  'companies': 'Company',
  'status': 'Status',
  'isActive': 'Active',
  'avatar': 'Avatar',
  'office.countryCode': 'Office > Country Code',
  'office.phoneNumber': 'Office > Phone Number',
  'phone.countryCode': 'Home Tel. > Country Code',
  'phone.phoneNumber': 'Home Tel. > Phone Number',
  'mobile.countryCode': 'Mobile > Country Code',
  'mobile.phoneNumber': 'Mobile > Phone Number',
  'fax.countryCode': 'Fax > Country Code',
  'fax.phoneNumber': 'Fax > Phone Number',
  'companies.name': 'Name',
  'roles': 'Roles',
  'roles.name': 'Name'
};


export const RECORD_TYPES_CONFIG: Record<RecordTypesConfig, OptionDescription<RecordTypesConfig>> = {
  [RecordTypesConfig.UserEntity]: {
    id: RecordTypesConfig.UserEntity,
    value: RecordTypesConfig.UserEntity,
    name: 'User Account',
    viewValue: 'User Account',
    fieldNameMap: { ...fieldNameMapConfig, ...fieldNameMapUserAccount },
    fieldsHide: [...generalFieldsHide, ...userAccountFieldsHide],
    fieldsImage: ['avatar'],
    fieldsAlign: [{ fieldName: 'roles', key: 'id' }] as IAuditTrailAlignField[]
  },
  [RecordTypesConfig.RoleEntity]: {
    id: RecordTypesConfig.RoleEntity,
    value: RecordTypesConfig.RoleEntity,
    name: 'Roles',
    viewValue: 'Roles',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'permissions.description']
  },
  [RecordTypesConfig.PermissionEntity]: {
    id: RecordTypesConfig.PermissionEntity,
    value: RecordTypesConfig.PermissionEntity,
    name: 'Permissions',
    viewValue: 'Permissions',
    fieldNameMap: { ...fieldNameMapConfig, 'isActive': 'Active' },
    fieldsHide: [...generalFieldsHide, 'slug']
  },
  [RecordTypesConfig.LookupEntity]: {
    id: RecordTypesConfig.LookupEntity,
    value: RecordTypesConfig.LookupEntity,
    name: 'Lookup Tables',
    viewValue: 'Lookup Tables',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide],
    fieldsAlign: [{ fieldName: 'cells', key: 'sequence' }] as IAuditTrailAlignField[]
  },
  [RecordTypesConfig.BankEntity]: {
    id: RecordTypesConfig.BankEntity,
    value: RecordTypesConfig.BankEntity,
    name: 'Bank',
    viewValue: 'Bank',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.ContactCategoryEntity]: {
    id: RecordTypesConfig.ContactCategoryEntity,
    value: RecordTypesConfig.ContactCategoryEntity,
    name: 'Contact Category',
    viewValue: 'Contact Category',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'description']
  },
  [RecordTypesConfig.CountryEntity]: {
    id: RecordTypesConfig.CountryEntity,
    value: RecordTypesConfig.CountryEntity,
    name: 'Country',
    viewValue: 'Country',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'isDefault', 'defaultCurrency.code']
  },
  [RecordTypesConfig.CurrencyEntity]: {
    id: RecordTypesConfig.CurrencyEntity,
    value: RecordTypesConfig.CurrencyEntity,
    name: 'Currency',
    viewValue: 'Currency',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'symbol']
  },
  // [RecordTypesConfig.DepartmentEntity]: {
  //   id: RecordTypesConfig.DepartmentEntity,
  //   value: RecordTypesConfig.DepartmentEntity,
  //   name: 'Department',
  //   viewValue: 'Department',
  //   fieldNameMap: fieldNameMapConfig,
  //   fieldsHide: [...generalFieldsHide]
  // },
  [RecordTypesConfig.DialectEntity]: {
    id: RecordTypesConfig.DialectEntity,
    value: RecordTypesConfig.DialectEntity,
    name: 'Dialect',
    viewValue: 'Dialect',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.DisciplineEntity]: {
    id: RecordTypesConfig.DisciplineEntity,
    value: RecordTypesConfig.DisciplineEntity,
    name: 'Discipline',
    viewValue: 'Discipline',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.GSTRateEntity]: {
    id: RecordTypesConfig.GSTRateEntity,
    value: RecordTypesConfig.GSTRateEntity,
    name: 'GST Rate',
    viewValue: 'GST Rate',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'gstRate', 'name']
  },
  [RecordTypesConfig.IDTypeEntity]: {
    id: RecordTypesConfig.IDTypeEntity,
    value: RecordTypesConfig.IDTypeEntity,
    name: 'ID Type',
    viewValue: 'ID Type',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.NationalityEntity]: {
    id: RecordTypesConfig.NationalityEntity,
    value: RecordTypesConfig.NationalityEntity,
    name: 'Nationality',
    viewValue: 'Nationality',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'isDefault']
  },
  [RecordTypesConfig.QualificationEntity]: {
    id: RecordTypesConfig.QualificationEntity,
    value: RecordTypesConfig.QualificationEntity,
    name: 'Qualification',
    viewValue: 'Qualification',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.SchemeTypeEntity]: {
    id: RecordTypesConfig.SchemeTypeEntity,
    value: RecordTypesConfig.SchemeTypeEntity,
    name: 'Scheme Type',
    viewValue: 'Scheme Type',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesConfig.CommMatrixTypeEntity]: {
    id: RecordTypesConfig.CommMatrixTypeEntity,
    value: RecordTypesConfig.CommMatrixTypeEntity,
    name: 'Comm Matrix Type',
    viewValue: 'Comm Matrix Type',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'code']
  },
  [RecordTypesConfig.TransactionTypeEntity]: {
    id: RecordTypesConfig.TransactionTypeEntity,
    value: RecordTypesConfig.TransactionTypeEntity,
    name: 'Transaction Type',
    viewValue: 'Transaction Type',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide, 'code']
  },
  // [RecordTypesConfig.CategoryEntity]: {
  //   id: RecordTypesConfig.CategoryEntity,
  //   value: RecordTypesConfig.CategoryEntity,
  //   name: 'Category Type',
  //   viewValue: 'Category Type',
  //   fieldNameMap: fieldNameMapConfig,
  //   fieldsHide: [...generalFieldsHide]
  // },
};
